<template>
  <div class="main">
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"

        :html-to-pdf-options="{
          filename : 'Pedido Rápido - Qr Code',
          html2canvas: {
              scrollY: 0,
              width: 1550
            }
          }"
        
        @progress="onProgress($event)"
        @hasPaginated="hasPaginated()"
        @hasDownloaded="hasDownloaded($event)"
    >
        <section slot="pdf-content" class="pdf-content">
          <div style="position: relative">
            <div class="qr-code-printable square" :style="`background-color: ${color}`"></div>
            <div class="qr-code-printable square-2"></div>
            <img :src="require('@/assets/images/logo/logoForQrSmall.png')" class="qr-code-printable logo" />            
            <div class="qr-code-printable table-number"> MESA {{ String(table.number).padStart(2, '0') }} </div>
            <div class="qr-code-printable short-url" :style="`color: ${color}`"> {{ shortUrlId }} </div>
            <div class="qr-code-printable logo"></div>
            <div class="qr-code-printable image" ref="qrcode_print"></div>
          </div>
        </section>
      </vue-html2pdf>
    </div>

    <div>
      <div style="position: relative">
        <div class="qr-code-preview square" :style="`background-color: ${color}`"></div>
        <div class="qr-code-preview square-2"></div>
        <img :src="require('@/assets/images/logo/logoForQrSmall.png')" class="qr-code-preview logo">
        <div class="qr-code-preview table-number"> MESA {{ String(table.number).padStart(2, '0') }} </div>
        <div class="qr-code-preview logo"></div>
        <div class="qr-code-preview image" ref="qrcode_preview"></div>

        <!-- IMAGE BASE64 -->
      </div>
    </div>
  </div>
</template>

<script>
  import * as qrCode from 'easyqrcodejs'
  import VueHtml2pdf from 'vue-html2pdf'
  import downloadQrCode from '../downloadQrCode'

  export default {
    name: 'One',
    props:{
      includeLogo: {
        required: true,
        type: Number,
        default: 1,
      },
      table: {
        required: false,
        type: Object,
      },
      preview: {
        required: false,
        type: Boolean,
      },
      color: {
        required: false,
        type: String,
      },
    },
    
    components : {
      VueHtml2pdf,
      'qr-code' : qrCode
    },

    mixins: [downloadQrCode(860, 860)],

    data() {
      return {
        qrCodePreview: null,
        qrCodePrintDrawn: '',
        shortUrlId: '',
        customerLogo: '',
      }
    },

    mounted() {
      if(!Object.keys(this.table).length) return
      this.shortUrlId = this.table.shortUrl.substring(this.table.shortUrl.length - 6, this.table.shortUrl.length);
      this.generateQrCodePreview()
    },

    methods: {

      generateQrCodePreview() {
        this.qrCodePreview = new qrCode(this.$refs.qrcode_preview, {
          text: this.table.shortUrl,
          width: 105,
          height: 105,
          quietZone: 0,
          quietZoneColor: 'transparent',
        })
      },

      onProgress (e) {
        if(e < 100) {
          this.$emit('downloading', true)
        }
      },

      hasPaginated () {
        console.log('hasPaginated')
        this.$emit('hasPaginated')
      },

      hasDownloaded () {
        console.log('download finalizado')
        this.$emit('downloaded', true)
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/components/table/templates/one/css/main.scss';
</style>